import styled from "styled-components";
import { DefaultParagraphLargeFactory, DefaultTitleLargeFactory } from '../core/Typograph/Typograph.Style'

export const Banner = styled.div(({theme}) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxHeight: "428px",
    color: "white",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundColor: "#005FC8",

    [theme.breakpoint.md()]: {
        maxHeight: "216px",
    }
}));

export const Content = styled.div(({theme}) => ({
    display: "block",
    margin: "40px 20px",
    gap: "32px",

    [theme.breakpoint.md()]: {
        margin: "60px 112px",
    }
}))

export const MainTitle = styled.h2(({theme}) => ({
    ...DefaultTitleLargeFactory({theme})
}));

export const MainText = styled.p(({theme}) => ({
    ...DefaultParagraphLargeFactory({theme}),
    textAlign: "left",
}));

export const icon = styled.div(() => ({
    display: "flex",
    alignItems: "center",
}))

export const TextWithIcon = styled.div(({theme}) => ({
    display: "flex",
    gap: "16px",
    alignItems: "center",

    [theme.breakpoint.md()]: {
        gap: "44px",
    }
}));